import PrintSettings from '../../components/PrintSettings';

export default function PrintSettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Print Settings</h1>
        <p className="text-slate-500">Configure thermal printers for receipts and kitchen tickets</p>
      </div>
      <PrintSettings />
    </div>
  );
}
